import React from "react";
import Img from "gatsby-image";
import { getFluidGatsbyImage } from "gatsby-source-sanity";

import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImageData } from "gatsby-source-sanity";
import clientConfig from "../../client-config";
import styled from "styled-components";

export default ({ node }) => {
  if (!node.asset) {
    return null;
  }

  // const fluidProps = getFluidGatsbyImage(node.asset._ref, { maxWidth: 675 }, clientConfig.sanity);
  const imageData = getGatsbyImageData(node.asset, { maxWidth: 675 }, clientConfig.sanity);

  const Figure = styled.figure`
    margin: 2rem 0;
    width: 50%;
    text-align: center;
    margin: 0 auto;
  `;
  const FigCaption = styled.figcaption`
    font-size: 14px;
    line-height: 21px;
    margin: 0.5rem 0 0;
  `;

  return (
    <Figure>
      {/* <Img fluid={fluidProps} alt={node.alt} /> */}
      <GatsbyImage image={imageData} alt={node.alt} />
      {node.caption && <FigCaption>{node.caption}</FigCaption>}
    </Figure>
  );
};
